import React, { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { TableControls } from '../../../../BaseEditor';

function Row({
  row, fields, actions, readOnly, active, mode,
}) {
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      {mode === 'land' && (
      <TableCell>
        <TableControls.ItemPicker
          value={row.land}
          onChange={(e, v) => actions.onChange(e, row.id, { land: v })}
          backend={fields.land.resource}
          readOnly={fields.land.read_only || readOnly}
        />
      </TableCell>
      )}
      {mode === 'easement' && (
      <TableCell>
        <TableControls.ItemPicker
          value={row.easement}
          onChange={(e, v) => actions.onChange(e, row.id, { easement: v })}
          backend={fields.easement.resource}
          readOnly={fields.easement.read_only || readOnly}
        />
      </TableCell>
      )}
      {mode === 'realty' && (
      <TableCell>
        <TableControls.ItemPicker
          value={row.realty}
          onChange={(e, v) => actions.onChange(e, row.id, { realty: v })}
          backend={fields.realty.resource}
          readOnly={fields.realty.read_only || readOnly}
        />
      </TableCell>
      )}
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    land: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
    }),
    easement: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
    }),
    realty: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
    }),
  }).isRequired,
  fields: PropTypes.shape({
    land: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
    easement: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
    realty: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  active: PropTypes.bool,
  mode: PropTypes.oneOf(['land', 'easement', 'realty']).isRequired,
};

Row.defaultProps = {
  readOnly: false,
  active: false,
};

export default memo(Row);
